import { render, staticRenderFns } from "./ShopMenuBookCollection.vue?vue&type=template&id=4cd00fbc&scoped=true&"
import script from "./ShopMenuBookCollection.vue?vue&type=script&lang=js&"
export * from "./ShopMenuBookCollection.vue?vue&type=script&lang=js&"
import style0 from "./ShopMenuBookCollection.vue?vue&type=style&index=0&id=4cd00fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd00fbc",
  null
  
)

export default component.exports